import type { SseLogoutListener, SseManager } from "@/types";
import { toStringOrNull } from "@/utils";

export const buildSseManager = (
  cosIdHost: string,
  installationId: string,
  clientId: string
): SseManager => {
  return {
    bindLogoutUrl:
      `${cosIdHost}/vnts/cosid/api/sse/logout?id=${encodeURIComponent(
        installationId
      )}` + `&channel=${encodeURIComponent(clientId)}`,
    bindId: installationId,
    timeout: 480,
  };
};

const createSseLogoutListener = (): SseLogoutListener => {
  let es: EventSource | null = null;

  const close = () => {
    try {
      es?.close();
    } catch {}
    es = null;
  };

  const start = (url: string, onLogout: (raw: string | null) => void) => {
    if (es) return;

    es = new EventSource(url, { withCredentials: false });

    const handleEvent = (e: MessageEvent) => onLogout(toStringOrNull(e.data));

    es.onmessage = handleEvent;
    es.addEventListener("logout-event", handleEvent);
    // optional: auto-cleanup on error
    es.onerror = () => {
      // close();
    };
  };

  const isActive = () => es != null;

  return { start, close, isActive };
};

export const sseLogoutListener = createSseLogoutListener();
